import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Parser as JSON2CSVParser } from 'json2csv';
import SubHeader from './SubHeader';
import SelectableVehicles from './SelectableVehicles';

import './VehiclesManagerDashboard.css';

@inject('subscriptionsStore', 'commonStore', 'translationsStore', 'filterStore', 'fleetCustomerContractsStore')
@observer
class VehiclesManagerDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.loadResources();
  }

  componentWillUnmount = () => {
    this.props.filterStore.reset();
  };

  loadResources = () => {
    const { fleetCustomerContractsStore, commonStore } = this.props;
    commonStore.setLoading(true);
    setTimeout(() => {
      Promise.all([fleetCustomerContractsStore.load()]).then(() => {
        commonStore.setLoading(false);
      });
    }, 200);
  };

  onExport = () => {
    const { fleetCustomerContractsStore, translationsStore } = this.props;
    if (fleetCustomerContractsStore.filtered.length > 0) {
      const fields = [
        {
          label: translationsStore.translate('vehiclesManager.vehicleTable.headerLabels.plate'),
          value: row => (row.activeVehicle ? row.activeVehicle.license_plate : '')
        },
        {
          label: translationsStore.translate('vehiclesManager.vehicleTable.headerLabels.make'),
          value: row => (row.activeVehicle ? row.activeVehicle.brand.name : '')
        },
        {
          label: translationsStore.translate('vehiclesManager.vehicleTable.headerLabels.model'),
          value: row => (row.activeVehicle ? row.activeVehicle.model.name : '')
        },
        {
          label: translationsStore.translate('vehiclesManager.vehicleTable.headerLabels.status'),
          value: row => translationsStore.translate(`vehiclesManager.status.${row.managementStatus}`)
        },
        {
          label: translationsStore.translate('vehiclesManager.vehicleTable.headerLabels.statusDate'),
          value: row => new Date(row.managementStatusDate).toLocaleDateString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit' })
        },
        {
          label: translationsStore.translate('subscriptionManager.subscriptionTable.headerLabels.product'),
          value: row => (!!row.products && !!row.products[0].name ? row.products.map(element => element.name).reduce((result, item) => `${result}, ${item}`) : '-')
        },
        {
          label: translationsStore.translate('vehiclesManager.vehicleTable.headerLabels.installer'),
          value: row => (row.activeVehicleInstaller ? row.activeVehicleInstaller.company_name : '')
        }
      ];

      const exportFilename = 'myfleet.csv';
      try {
        const parser = new JSON2CSVParser({ fields, delimiter: ';', withBOM: true });
        const csv = parser.parse(fleetCustomerContractsStore.filtered);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');

        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', exportFilename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (err) {
        console.error(err);
      }
    }
  };

  render() {
    const { fleetCustomerContractsStore } = this.props;
    return (
      <div className={`VehiclesManagerDashboard ${this.props.commonStore.loading ? 'loading' : ''}`}>
        <SubHeader onExportClick={this.onExport} />
        {this.props.commonStore.loading === false && (
          <SelectableVehicles vehicles={fleetCustomerContractsStore.vehicles} vehiclesFiltered={fleetCustomerContractsStore.filtered} />
        )}
      </div>
    );
  }
}

export default VehiclesManagerDashboard;



// WEBPACK FOOTER //
// ./src/components/App/VehiclesManagerDashboard/VehiclesManagerDashboard.js